import { render, staticRenderFns } from "./praiseOrder.vue?vue&type=template&id=36acfbe1&scoped=true&"
import script from "./praiseOrder.vue?vue&type=script&lang=js&"
export * from "./praiseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36acfbe1",
  null
  
)

export default component.exports